import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import Grid2 from '@mui/material/Grid2';
import React from 'react';
import { useStackModalContext } from '../context/StackModalContext';
import ControlModeItem from './ControlModeItem';

const ControlModeList: React.FC = () => {
  const {
    state: { controlModes },
    actions: {
      controlMode: { handleAddControlMode },
    },
  } = useStackModalContext();

  return (
    <>
      <Grid2 container direction='column' sx={{ mt: 2 }}>
        {controlModes.map((controlMode, index) => (
          <Grid2 key={`control-mode-grid-${index}`} size={12}>
            <ControlModeItem
              key={`control-mode-item-${index}`}
              controlMode={controlMode}
              index={index}
            />
          </Grid2>
        ))}
      </Grid2>

      <Grid2 sx={{ mt: 2 }}>
        <Button startIcon={<AddIcon />} onClick={handleAddControlMode}>
          Add Control Mode
        </Button>
      </Grid2>
    </>
  );
};

export default React.memo(ControlModeList);
